import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LicenseFeaturesService} from '../../../services/common/license-features/license-features.service';
import {LicenseApiService} from '../../../services/api/settings/administration/license/license-api.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Component({
  selector: 'license-settings',
  templateUrl: './license-settings.component.html',
  styleUrls: ['./license-settings.component.scss']
})
export class LicenseSettingsComponent implements OnInit {

  @ViewChild('tooltip', {static: true}) tooltip;

  canSubmit: boolean;
  license: any = {};
  machineId: any = {};

  constructor(private userPrivilege: UserPrivilegeService,
              private licenseFeaturesService: LicenseFeaturesService,
              private licenseApiService: LicenseApiService) { }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.initialiseLicense();
    this.initialiseMachineId();
  }

  initialiseLicense(): void {
    this.licenseApiService.getLicense().subscribe((license: any) => {
      this.license = license;

      if (this.license.limitedByDate && this.license.licenseDate) {
        const day = this.license.licenseDate.day.toString();
        const month = this.license.licenseDate.month.toString();
        const year = this.license.licenseDate.year.toString();
        this.license.expirationDate = ((day.length === 1) ? '0' + day : day) + '-' +
            ((month.length === 1) ? '0' + month : month) + '-' +
            year.toString();
      } else {
        this.license.expirationDate = 'Unlimited';
      }
    });
  }

  initialiseMachineId(): void {
    this.licenseApiService.getMachineId().subscribe((machineId) => {
      this.machineId = machineId;
    });
  }

  onSubmit(): void {
    this.licenseApiService.editLicense({license: this.license.license}).subscribe(() => {
      this.initialiseLicense();

      this.licenseFeaturesService.refresh();
    });
  }

  copyMachineIdToClipboard(): void {
    this.tooltip.message = 'Copied';
    setTimeout(() => { this.tooltip.show(); }, 0);
  }

  mouseEnterCopyToClipboard(): void {
    this.tooltip.message = 'Copy to clipboard';
  }
}
